/* Nazrin theme — vanilla JS, no build step.
   Handles: header scroll, mobile menu, cart drawer, accordions,
   qty steppers, product tabs, testimonial slider. */

(function () {
  'use strict';

  const $  = (s, ctx) => (ctx || document).querySelector(s);
  const $$ = (s, ctx) => Array.from((ctx || document).querySelectorAll(s));

  // ── Header: subtle shadow once scrolled ─────────────────────────────────
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Mobile menu toggle ──────────────────────────────────────────────────
  $$('[data-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.body.classList.toggle('menu-open');
    });
  });
  $$('[data-menu-close]').forEach((btn) => {
    btn.addEventListener('click', () => document.body.classList.remove('menu-open'));
  });

  // ── Cart drawer open/close ──────────────────────────────────────────────
  const drawer = $('.cart-drawer');
  const scrim  = $('.cart-drawer-scrim');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('open');
    scrim && scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open');
    scrim && scrim.classList.remove('open');
    document.body.style.overflow = '';
  }
  window.openCart = openCart;
  window.closeCart = closeCart;

  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => {
    if (b.dataset.cartType === 'page') return;       // let link nav through
    e.preventDefault(); openCart();
  }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeCart));
  scrim && scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  // ── Cart fetch / render ─────────────────────────────────────────────────
  function eur(cents) {
    const n = (cents / 100);
    return '€' + n.toFixed(2).replace('.', ',');
  }

  function fetchCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then(renderCart)
      .catch(() => {});
  }
  window.fetchCart = fetchCart;

  function renderCart(cart) {
    const body = $('.cart-drawer-body');
    const sub  = $('.cart-drawer-subtotal-value');
    const count = $$('.cart-count');

    count.forEach((el) => { el.textContent = cart.item_count; });

    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = `
        <div class="cart-drawer-empty">
          <div class="script">Your bag is quiet</div>
          <p>Explore the studio — pick something to keep you company.</p>
          <a class="btn btn-ghost" href="/collections/all">Browse the shop</a>
        </div>`;
      sub && (sub.textContent = eur(0));
      return;
    }

    body.innerHTML = cart.items.map((it) => `
      <div class="cart-line" data-key="${it.key}">
        <div class="cart-line-img">
          ${it.image ? `<img src="${it.image}" alt="${it.product_title}">` : `<div class="image-placeholder"></div>`}
        </div>
        <div class="cart-line-info">
          <div class="cart-line-name">${it.product_title}</div>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="cart-line-variant">${it.variant_title}</div>` : ''}
          <div class="cart-line-bottom">
            <div class="qty-stepper">
              <button data-qty-dec aria-label="Decrease">−</button>
              <span class="num">${it.quantity}</span>
              <button data-qty-inc aria-label="Increase">+</button>
            </div>
            <div class="cart-line-price">${eur(it.final_line_price)}</div>
          </div>
        </div>
        <button class="cart-line-remove" data-qty-remove aria-label="Remove">×</button>
      </div>`).join('');

    sub && (sub.textContent = eur(cart.total_price));

    // Bind qty handlers
    $$('.cart-line', body).forEach((line) => {
      const key = line.dataset.key;
      line.querySelector('[data-qty-dec]').addEventListener('click', () => updateQty(key, getQty(line) - 1));
      line.querySelector('[data-qty-inc]').addEventListener('click', () => updateQty(key, getQty(line) + 1));
      line.querySelector('[data-qty-remove]').addEventListener('click', () => updateQty(key, 0));
    });
  }
  function getQty(line) { return parseInt(line.querySelector('.qty-stepper .num').textContent, 10) || 0; }

  function updateQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
    }).then((r) => r.json()).then(renderCart).catch(() => {});
  }

  // ── Add-to-cart forms — intercept and open drawer ───────────────────────
  $$('form[action^="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const cartType = form.dataset.cartType || 'drawer';
      if (cartType === 'page') return; // let it submit normally
      e.preventDefault();
      const fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then(() => { fetchCart(); openCart(); })
        .catch(() => { form.submit(); });
    });
  });

  // ── Accordions ──────────────────────────────────────────────────────────
  $$('.accordion').forEach((acc) => {
    $$('.acc-head', acc).forEach((head) => {
      head.addEventListener('click', () => {
        const item = head.closest('.acc-item');
        const wasOpen = item.classList.contains('open');
        if (!acc.dataset.multi) {
          $$('.acc-item', acc).forEach((i) => i.classList.remove('open'));
        }
        if (!wasOpen) item.classList.add('open');
      });
    });
  });

  // ── Quantity steppers (PDP, cart page) ──────────────────────────────────
  $$('.qty-stepper[data-pdp]').forEach((s) => {
    const input = s.querySelector('input[name="quantity"]');
    const num   = s.querySelector('.num');
    const dec   = s.querySelector('[data-dec]');
    const inc   = s.querySelector('[data-inc]');
    const get   = () => parseInt((input ? input.value : num.textContent), 10) || 1;
    const set   = (v) => {
      v = Math.max(1, v);
      if (input) input.value = v;
      if (num) num.textContent = v;
    };
    dec && dec.addEventListener('click', () => set(get() - 1));
    inc && inc.addEventListener('click', () => set(get() + 1));
  });

  // ── Product variant selection (PDP option pills) ────────────────────────
  const pdp = $('[data-product-json]');
  if (pdp) {
    let product;
    try { product = JSON.parse(pdp.textContent); } catch (e) { product = null; }
    if (product) {
      const form = $('form[data-product-form]');
      const variantInput = form && form.querySelector('input[name="id"]');
      const priceEl = $('[data-product-price]');
      const submitBtn = form && form.querySelector('[data-add-btn]');

      const chips = $$('[data-option-index]');
      const selected = product.options.map((_, i) => {
        const v = product.variants[0].options[i];
        return v;
      });

      const updateVariant = () => {
        const variant = product.variants.find((v) =>
          selected.every((val, i) => v.options[i] === val)
        );
        if (!variant) return;
        variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = eur(variant.price);
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available
            ? submitBtn.dataset.addLabel + ' · ' + eur(variant.price)
            : 'Sold out';
        }
      };

      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const i = parseInt(chip.dataset.optionIndex, 10);
          const value = chip.dataset.optionValue;
          selected[i] = value;
          $$(`[data-option-index="${i}"]`).forEach((c) => c.classList.remove('active'));
          chip.classList.add('active');
          const lab = chip.closest('.opt-group');
          if (lab) {
            const sel = lab.querySelector('.opt-label .selected');
            if (sel) sel.textContent = value;
          }
          updateVariant();
        });
      });
      updateVariant();
    }
  }

  // ── Product tabs (featured-collection by category) ──────────────────────
  $$('[data-tabs]').forEach((tabs) => {
    const buttons = $$('[data-tab]', tabs);
    const panels  = $$('[data-panel]', tabs.parentElement);
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach((b) => b.classList.toggle('active', b === btn));
        const target = btn.dataset.tab;
        panels.forEach((p) => p.classList.toggle('active', p.dataset.panel === target));
      });
    });
  });

  // ── Testimonial slider ──────────────────────────────────────────────────
  $$('[data-testimonials]').forEach((box) => {
    const track   = $('.t-track', box);
    const wrap    = $('.t-track-wrap', box);
    const cards   = $$('.t-card', track);
    const dotsBox = $('.t-dots', box);
    const ctrls   = $('.t-controls', box);
    const prev    = $('[data-t-prev]', box);
    const next    = $('[data-t-next]', box);
    const gap     = 32;
    let i = 0;
    let max = 0;

    // How many cards fit in the viewport right now (responsive).
    const visibleCount = () => {
      if (!cards[0] || !wrap) return 1;
      const cardW = cards[0].getBoundingClientRect().width + gap;
      const wrapW = wrap.getBoundingClientRect().width + gap;
      return Math.max(1, Math.round(wrapW / cardW));
    };

    // Rebuild dots to match reachable positions (max + 1).
    const buildDots = () => {
      if (!dotsBox) return;
      dotsBox.innerHTML = '';
      for (let j = 0; j <= max; j++) {
        const s = document.createElement('span');
        if (j === i) s.classList.add('active');
        s.addEventListener('click', () => { i = j; apply(); });
        dotsBox.appendChild(s);
      }
    };

    const apply = () => {
      const visible = visibleCount();
      max = Math.max(0, cards.length - visible);
      if (i > max) i = max;
      const cardW = cards[0] ? cards[0].getBoundingClientRect().width + gap : 0;
      track.style.transform = `translateX(${-i * cardW}px)`;
      if (ctrls) ctrls.style.display = max > 0 ? '' : 'none';
      buildDots();
    };

    prev && prev.addEventListener('click', () => { i = Math.max(0, i - 1); apply(); });
    next && next.addEventListener('click', () => { i = Math.min(max, i + 1); apply(); });
    window.addEventListener('resize', apply);
    apply();
  });

  // ── Initial cart prime so the badge is accurate ─────────────────────────
  fetchCart();

})();
